import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function AdminPayouts() {
  const [payouts, setPayouts] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [note, setNote] = useState("");

  const refresh = () => api.get("/payouts").then(r => setPayouts(r.data));
  useEffect(() => { refresh(); }, []);

  const markPaid = async () => {
    await api.post(`/payouts/${openId}/mark-paid`, { admin_note: note });
    toast.success("Markeret som betalt");
    setOpenId(null);
    setNote("");
    refresh();
  };

  const pending = payouts.filter(p => p.status === "pending");
  const paid = payouts.filter(p => p.status === "paid");

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Udbetalinger</h1>

      <Card className="mb-6">
        <CardHeader><CardTitle>Afventer ({pending.length})</CardTitle></CardHeader>
        <CardContent>
          {pending.length === 0 ? <p className="text-sm text-muted-foreground text-center py-6">Ingen afventende</p> : (
            <div className="space-y-2">
              {pending.map(p => (
                <div key={p.id} className="flex items-center justify-between p-3 rounded-lg border border-border">
                  <div className="text-sm">
                    <p className="font-semibold">{p.driver_name || p.driver_email}</p>
                    <p className="text-xs text-muted-foreground">Bank: {p.bank_reg} {p.bank_account} · Job #{p.job_id.slice(0,8)}</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="font-bold">{p.amount} kr.</span>
                    <Button size="sm" onClick={() => setOpenId(p.id)}>Marker betalt</Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Betalte ({paid.length})</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-2">
            {paid.slice(0, 20).map(p => (
              <div key={p.id} className="flex items-center justify-between p-3 rounded-lg border border-border opacity-70">
                <span className="text-sm">{p.driver_name || p.driver_email} · {new Date(p.paid_at).toLocaleDateString("da-DK")}</span>
                <Badge>{p.amount} kr.</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Dialog open={!!openId} onOpenChange={(o) => !o && setOpenId(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>Markér som betalt</DialogTitle></DialogHeader>
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reference / note (valgfri)" />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenId(null)}>Annuller</Button>
            <Button onClick={markPaid}>Bekræft</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
